var _polygon, _path, _path2, _path3, _path4, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51.1 52.6",
    style: {
      enableBackground: "new 0 0 51.1 52.6"
    },
    xmlSpace: "preserve",
    fill: "#333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "36.7,25.4 46.3,25.4 51.1,17.2 46.3,9 36.7,9 31.9,17.2 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7,27.4l-4.8,8.3l4.8,8.2h9.6l4.8-8.2l-4.8-8.3H36.7z M44.9,41.6h-6.8l-3.4-5.8l3.4-5.9h6.8l3.4,5.9L44.9,41.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,27.4H4.9L0,35.7l4.9,8.2h9.6l4.8-8.2L14.5,27.4z M13,41.6H6.2l-3.4-5.8l3.4-5.9H13l3.4,5.9L13,41.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4,16.5l4.8-8.3L30.4,0h-9.6L16,8.2l4.8,8.3H30.4z M22.2,2.4H29l3.4,5.8L29,14.1h-6.8l-3.4-5.9L22.2,2.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8,17.9L16,26.1l4.8,8.3h9.6l4.8-8.3l-4.8-8.2H20.8z M29,32.1h-6.8l-3.4-5.9l3.4-5.8H29l3.4,5.8L29,32.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.8,36.2 16,44.4 20.8,52.6 30.3,52.6 35.2,44.4 30.3,36.2 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.4,25.4 19.2,17.2 14.4,9 4.9,9 0.1,17.2 4.9,25.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon);
export default __webpack_public_path__ + "static/media/services_icon.2c03107d1040fc38396b19b73240c6a1.svg";
export { ForwardRef as ReactComponent };